import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function TheName() {
  useReveal();
  const { c } = useSite();
  const { name } = c;
  return (
    <section id="name" className="bg-parchment text-ink py-28 sm:py-40 grain relative">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-7">
            <span className="eyebrow text-oxblood">{name.label}</span>
          </div>
          <h2 className="font-display text-5xl sm:text-7xl font-light tracking-wide">{name.title}</h2>
          <p className="mt-6 text-xl leading-relaxed text-ink/70 font-light">{name.intro}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-20 max-w-4xl mx-auto">
          {name.parts.map((p) => (
            <div key={p.word} className="reveal border-t border-ink/20 pt-7">
              <div className="flex items-baseline justify-between gap-4">
                <span className="font-display text-4xl sm:text-5xl font-medium">{p.word}</span>
                <span className="font-label text-[0.68rem] uppercase tracking-[0.18em] text-ink/70">{p.gloss}</span>
              </div>
              <p className="mt-4 text-lg leading-relaxed text-ink/70 font-light">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-16 max-w-3xl mx-auto text-center border border-oxblood/30 bg-white/40 py-12 px-6">
          <span className="font-display text-5xl sm:text-6xl font-light text-oxblood">{name.combined.word}</span>
          <p className="font-display italic text-2xl mt-3 text-ink/80">{name.combined.gloss}</p>
          <p className="font-label text-[0.68rem] uppercase tracking-[0.3em] text-ink/50 mt-5">{name.combined.pron}</p>
        </div>

        <p className="reveal text-center font-display italic text-xl text-ink/60 mt-12 max-w-2xl mx-auto">
          {name.kindred}
        </p>
      </div>
    </section>
  );
}
